angular.module('gym.components').controller('ShowSuspensionHistoryModalCtrl', ["$scope", "$rootScope", "$modalInstance", "$http", "flash", "suspension", function($scope, $rootScope, $modalInstance, $http, flash, suspension) {
  var gym, loadHistory;
  gym = $rootScope.gym;
  loadHistory = function() {
    var url;
    url = `/gyms/${gym.id}/suspension_histories?contact_suspension_id=${suspension.id}&count=100`;
    return $http.get(url).then(function(response) {
      return $scope.history = response.data.collection;
    }, function() {
      return flash.error = "There was an error processing the request.";
    });
  };
  loadHistory();
  return $scope.cancel = function() {
    return $modalInstance.dismiss('cancel');
  };
}]);
